// Types
export type CategoryType = {
  category: {
    id: string;
    name: string;
  }[];
  name: string;
}[];

// Constants
export const CREATE_PRODUCT: string = "Create Product";
export const HOME: string = "Home";
export const PRODUCTS: string = "Products";
export const SORT: string = "Sort";
export const DELTA: string = "Delta";
export const PRODUCT_TYPE: string = "Product type";
export const CATEGORY_LIST: string = "Category List";


// Path
export const PRODUCT_DELTA_CATEGORY_LIST: string = "/gms/products/category/list";
export const PRODUCT_DELTA_LIST: string = "/gms/products/list";
export const PRODUCT_CREATE: string = "/gms/product/edit/0";
export const PRODUCT_DETAIL_PREVIEW = "/gms/product/details/001c2000f1e94705b41716a2fc8e163a";

// Bulk Action Menu Items
export const PARENT_CHILD: string = "Parent/Child";
export const CREATE_PARENT: string = "Create Parent";
export const MOVE_TO_PARENT: string = "Move to Parent";
export const REMOVE_CHILD: string = "Remove Child";
export const PUBLISH_UNPUBLISH: string = "Publish/Unpublish";
export const PUBLISH_SELECTED: string = "Publish Selected";
export const UNPUBLISH_SELECTED: string = "Unpublish Selected";
export const CREATE_UPDATE: string = "Create/Update";
export const UPDATE: string = "Update";
export const UPLOAD: string = "Upload";
export const PDW_CREATE:string = "Create";
export const PDW_UPDATE:string = "Update";
export const PDW_VALIDATE:string = "Validate";
export const RECATEGORIZE:string = "Recategorize";
export const DOWNLOAD_ALL_AS_XLS: string = "Download all as XLS";
export const DOWNLOAD_TEMPLATE: string = "Download Template";
export const VIEW_LOGS: string = "View Logs";
export const BULK_DELETE: string = "Bulk Delete";
export const DELETE_SELECTED: string = "Delete Selected";
export const UPLOAD_XLS: string = "Upload XLS";


// Product Form
export const NAME_INFO = "Name must be 2-60 characters long, contain letters, numbers and spaces, and must not contain specialcharacters."

// for rule rerun on manage products
export const LOADING = "Loading";
export const SUCCESS = "Success";
export const ERROR = "Error";




